angular.module('surfsightApp.controllers').controller('versionController', [
  '$scope',
  '$rootScope',
  '$state',
  '$stateParams',
  '$timeout',
  '$interval',
  '$location',
  '$window',
  '$http',
  '$filter',
  '$localStorage',
  '$mdDialog',
  '$mdSidenav',
  '$mdToast',
  '$mdColors',
  '$mdMedia',
  'edgeFactory',
  'edgeGroupFactory',
  'broadcastViewFactory',
  'leafletData',
  'leafletBoundsHelpers',
  'nominatimLookUp',
  'configurationService',
  function (
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $timeout,
    $interval,
    $location,
    $window,
    $http,
    $filter,
    $localStorage,
    $mdDialog,
    $mdSidenav,
    $mdToast,
    $mdColors,
    $mdMedia,
    edgeFactory,
    edgeGroupFactory,
    broadcastViewFactory,
    leafletData,
    leafletBoundsHelpers,
    nominatimLookUp,
    configurationService
  ) {
    var $translate = $filter('translate')
    var counter = 0

    $scope.versionNumber = angular.copy(SURFSIGHT_VERSION)
    $scope.cancel = function () {
      $mdDialog.cancel()
    }

    $scope.incNewAppSupportCounter = incNewAppSupportCounter

    function incNewAppSupportCounter () {
      ++counter
      if (counter >= 5) {
        configurationService.setNewVersionSupportState(true)
      }
    }
  }
])
